import { Stack, Typography } from '@mui/material';
import { ColumnDefinition } from '../common/table/ColumnDefinition';
import Table from '../common/table/Table';
import Nedladdningslankar from './Nedladdningarlankar';
import { MetriaAktMetadata } from './types/MetriaAktMetadata';

interface AktListaProps {
  akter?: MetriaAktMetadata[];
  deleteAkter: (ids: number[]) => Promise<void>;
}

const AktLista: React.FC<AktListaProps> = ({ akter, deleteAkter }) => {
  const columnHeaders: Record<'id' | 'header', string>[] = [
    {
      id: 'aktbeteckning',
      header: 'Aktbeteckning',
    },
    {
      id: 'registreradTidpunkt',
      header: 'Tidpunkt',
    },
    {
      id: 'kundmarke',
      header: 'Kundmärke',
    },
    {
      id: 'storlek',
      header: 'Storlek',
    },
  ];

  const columnDefinitions: ColumnDefinition<MetriaAktMetadata>[] = [
    {
      id: 'aktbeteckning',
      header: 'Aktbeteckning',
      action: () => {},
      width: 40,
    },
    {
      id: 'registreradTidpunkt',
      header: 'Tidpunkt',
      width: 100,
    },
    {
      id: 'kundmarke',
      header: 'Kundmärke',
      width: 100,
    },
    {
      id: 'storlek',
      header: 'Storlek',
      width: 100,
    },
    {
      id: 'links',
      header: 'Nedladdningslänkar',
      render: (a) => <Nedladdningslankar akt={a} />,
      width: 100,
    },
  ];

  return (
    <Stack spacing={2} sx={{ mt: 4, pl: 2, pr: 2 }}>
      <Typography
        variant="h6"
        color="primary"
        sx={{ marginBottom: '-20px !important' }}
      >
        Sparade akter
      </Typography>
      <Table
        data={akter}
        rowsPerPage={10}
        columnHeaders={columnHeaders}
        columnDefinitions={columnDefinitions}
        deleteMultiIds={(ids) => deleteAkter(ids)}
        sortColumn={'registreradTidpunkt'}
        sortOrder="desc"
        sortType="Date"
      />
    </Stack>
  );
};

export default AktLista;
